// src/components/Header/Header.js
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../../Assets/Image/logo.jpg';

const Header = () => {
  const [showSearch, setShowSearch] = useState(false);
  const [isNavbarActive, setNavbarActive] = useState(false);
  const [activeDropdowns, setActiveDropdowns] = useState(new Set());
  const headerRef = useRef(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const menuItems = [
    {
      id: 'destinations',
      title: 'Destinations',
      type: 'link',
      path: '/destinations'
    },
    {
      id: 'attractions',
      title: 'Attractions',
      type: 'dropdown',
      items: [
        {
          id: 'historical',
          title: 'Historical Heritage',
          type: 'nested-dropdown',
          items: [
            { title: 'All Historical Heritages', path: '/historical' },
            { title: 'Archaeological Sites', path: '/archaeological-sites' },
            { title: 'All Zones', path: '/zonesinafar' }
          ]
        },
        {
          id: 'natural',
          title: 'Natural Wonders',
          type: 'nested-dropdown',
          items: [
            { title: 'All Natural Wonders', path: '/natural' },
            { title: 'Volcanoes & Rift Valleys', path: '/adventure-activities' },
            { title: 'Salt Plains & Lakes', path: '/SaltPlainsAndLakes' },
            { title: 'Hydrothermal & Sulfur Springs', path: '/HydrothermalAndSulfurSprings' },
            { title: 'Desert & Canyons', path: '/desert-canyons' }
          ]
        },
        {
          title: 'Cultural Experiences',
          path: '/cultural-experiences',
          type: 'link'
        }
      ]
    },
    {
      id: 'facilities',
      title: 'Tourist Facilities',
      type: 'dropdown',
      items: [
        { title: 'Tour Agents', path: '/travelagencies' },
        { title: 'Hotels', path: '/hotels' },
        { title: 'Flights', path: '/flights' },
        { title: 'Things to Do', path: '/things-todo' },
        { title: 'Tourist Info Center', path: '/tourist-info' }
      ]
    },
    {
      id: 'news',
      title: 'Events & News',
      type: 'link',
      path: '/news-events'
    },
    {
      id: 'about',
      title: 'About',
      type: 'dropdown',
      items: [
        { title: 'About ACTB', path: '/about-actb' },
        { title: 'About AFAR', path: '/about-region' },
        { title: 'Mandate & Responsibility', path: '/mandate-responsibility' },
        { title: 'Organizational Structure', path: '/organizational-structure' },
        { title: 'Stakeholders', path: '/stakeholders' },
        { title: 'Contact Us', path: '/contact-us' }
      ]
    },
    {
      id: 'login',
      title: 'Login',
      type: 'link',
      path: '/login'
    }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setActiveDropdowns(new Set());
      }
    };
    window.addEventListener('scroll', handleScroll);
    document.addEventListener('click', handleClickOutside);
    return () => { window.removeEventListener('scroll', handleScroll);document.removeEventListener('click', handleClickOutside);
  };}, []);

  const toggleDropdown = (dropdownId) => {
    setActiveDropdowns(prev => {
      const newSet = new Set(prev);
      if (newSet.has(dropdownId)) {
        newSet.delete(dropdownId);
      } else {
        newSet.add(dropdownId);
      }
      return newSet;
    });
  };

  const renderMenuItem = (item) => {
    if (item.type === 'link') {
      return <Link to={item.path}>{item.title}</Link>;
    }

    if (item.type === 'dropdown' || item.type === 'nested-dropdown') {
      return (
        <div className="dropdown">
          <span 
            className="dropdown-toggle"
            onClick={() => toggleDropdown(item.id)}
          >
            {item.title}
          </span>
          <div className={`dropdown-content ${activeDropdowns.has(item.id) ? 'show' : ''}`}>
            {item.items.map((subItem, index) => (
              <div key={index}>
                {subItem.type === 'nested-dropdown' ? (
                  <div className="nested-dropdown">
                    <span 
                      onClick={() => toggleDropdown(`${item.id}-${subItem.id}`)}
                      className="dropdown-toggle"
                    >
                      {subItem.title}
                    </span>
                    <div className={`dropdown-content ${
                      activeDropdowns.has(`${item.id}-${subItem.id}`) ? 'show' : ''
                    }`}>
                      {subItem.items.map((nestedItem, idx) => (
                        <Link key={idx} to={nestedItem.path}>
                          {nestedItem.title}
                        </Link>
                      ))}
                    </div>
                  </div>
                ) : (
                  <Link to={subItem.path}>{subItem.title}</Link>
                )}
              </div>
            ))}
          </div>
        </div>
      );
    }
  };

  return (
    <header className={`headers ${isScrolled ? 'scrolled' : ''}`} ref={headerRef}>
      <div className="logo">
        <Link to="/">
          <img src={logo} alt="Afar Logo" />
        </Link>
        <h1>Visit Afar</h1>
      </div>

      <div className="hamburger" onClick={() => setNavbarActive(!isNavbarActive)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <nav className={`navbar ${isNavbarActive ? 'active' : ''}`}>
        <ul className="nav-list">
          {menuItems.map((item) => (
            <li key={item.id}>
              {renderMenuItem(item)}
            </li>
          ))}
        </ul>
      </nav>

      <div className="search">
        <button onClick={() => setShowSearch(!showSearch)} className="search-icon">
          <i className="fas fa-search"></i>
        </button>
        {showSearch && (
          <input 
            type="text" 
            placeholder="Search..." 
            className="search-input" 
            autoFocus
          />
        )}
      </div>
    </header>
  );
};

export default Header;